var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.798,
    cy: 19.0372,
    r: 17.8637,
    stroke: "#37994F",
    strokeWidth: 1.39198
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9916 15.5952C26.9113 17.3469 25.6899 19.7455 23.3194 22.791C20.8725 25.9731 18.8034 27.5641 17.1079 27.5641C16.0592 27.5641 15.1713 26.5958 14.4441 24.6593C13.0298 19.4683 12.4272 16.4268 11.258 16.4268C11.1214 16.4268 10.6513 16.7121 9.84373 17.2746L9 16.1817C11.0732 14.3617 13.0539 12.3367 14.2954 12.2242C15.6976 12.0876 16.5574 13.0479 16.8829 15.0969C18.036 22.3892 18.5462 23.4901 20.6435 20.1875C21.3948 18.9982 21.8006 18.0942 21.8569 17.4715C22.0497 15.6273 20.4185 15.7518 19.3136 16.2259C20.1976 13.3291 21.889 11.9229 24.3841 12.0033C26.2242 12.0515 27.0961 13.2528 26.9916 15.5952Z",
    fill: "#37994F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8cb1d2fee1c0936c2b8cabe45da3ab92.svg";
export { ForwardRef as ReactComponent };